(() => {
  const backdropUrl = 'https://cdn.shopify.com/s/files/1/0596/6325/3693/files/GL_0939.jpg?v=1789065065';
  const oldBackdropPattern = /000052660003_1\.jpg/i;
  const sectionSuffix = 'section_tab_collections_M3xApY';
  const products = [
    {
      title: 'Mega Golden Hour Letter in Holiday',
      url: '/products/golden-hour-initial-charm',
      image: 'https://cdn.shopify.com/s/files/1/0596/6325/3693/files/21_a01_b60bdd02-5d14-4969-8f78-509e7fbe2c82.png?v=1789060248',
      hoverImage: 'https://cdn.shopify.com/s/files/1/0596/6325/3693/files/GL_0196.jpg?v=1789069689',
      price: 'From $2,290.00 USD',
    },
    {
      title: 'Classic Golden Hour Letter in Holiday',
      url: '/products/classic-golden-hour-initial-charm',
      image: 'https://cdn.shopify.com/s/files/1/0596/6325/3693/files/20_a01.png?v=1789060328',
      hoverImage: 'https://cdn.shopify.com/s/files/1/0596/6325/3693/files/GL_0324_34e8fb00-c2c6-48e1-9028-9617398a4dd1.jpg?v=1789076132',
      price: 'From $2,290.00 USD',
    },
    {
      title: 'Mini Golden Hour Letter in Diamond',
      url: '/products/petite-golden-hour-initial-charm',
      image: 'https://cdn.shopify.com/s/files/1/0596/6325/3693/files/29_a.png?v=1789060302',
      hoverImage: 'https://cdn.shopify.com/s/files/1/0596/6325/3693/files/IMG_4752.jpg?v=1789072986',
      price: 'From $990.00 USD',
    },
    {
      title: 'Mega Golden Hour Letter in Diamond',
      url: '/products/mega-golden-hour-initial-in-diamond',
      image: 'https://cdn.shopify.com/s/files/1/0596/6325/3693/files/11_a_2b4188e8-21b9-4b52-a498-cf333bb94245.png?v=1789060335',
      hoverImage: 'https://cdn.shopify.com/s/files/1/0596/6325/3693/files/IMG_47482.jpg?v=1789075000',
      price: 'From $3,490.00 USD',
    },
    {
      title: 'Classic Golden Hour Letter in Diamond',
      url: '/products/classic-golden-hour-initial-in-diamond',
      image: 'https://cdn.shopify.com/s/files/1/0596/6325/3693/files/22_a_e89ac050-d81d-469c-baf6-264c251f33bb.png?v=1789060374',
      hoverImage: 'https://cdn.shopify.com/s/files/1/0596/6325/3693/files/GL_1369.jpg?v=1789062471',
      price: 'From $2,390.00 USD',
    },
  ];

  const isHome = () => document.body.classList.contains('template-index') || window.location.pathname === '/';

  const rewriteImageValue = (value) => {
    if (!value || !oldBackdropPattern.test(value)) return value;
    if (!value.includes(',')) return backdropUrl;

    return value
      .split(',')
      .map((candidate) => candidate.trim().replace(/\S*000052660003_1\.jpg\S*/i, backdropUrl))
      .join(', ');
  };

  const replaceBackdrop = () => {
    let changed = false;

    document.querySelectorAll('img, source').forEach((element) => {
      ['src', 'srcset', 'data-src', 'data-srcset'].forEach((attribute) => {
        const currentValue = element.getAttribute(attribute);
        const nextValue = rewriteImageValue(currentValue);

        if (nextValue && nextValue !== currentValue) {
          element.setAttribute(attribute, nextValue);
          changed = true;
        }
      });
    });

    return changed;
  };

  const findLifeSection = () =>
    document.querySelector(`[id^="TabCollections--"][id$="${sectionSuffix}"]`) ||
    document.getElementById(`TabCollections--${sectionSuffix}`) ||
    document.querySelector('.homepage-bestsellers-family');

  const escapeHtml = (value) =>
    String(value).replace(/[&<>"']/g, (character) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[character]));

  const ensureHoverStyles = () => {
    const style = document.getElementById('life-in-letters-hover-styles') || document.createElement('style');
    style.id = 'life-in-letters-hover-styles';
    style.textContent = `
      .homepage-bestsellers-family__image {
        position: relative;
        display: block;
        overflow: hidden;
        aspect-ratio: 1 / 1.1;
        background: #f7f6f4;
      }

      .homepage-bestsellers-family__image img.primary,
      .homepage-bestsellers-family__image img.secondary {
        position: absolute;
        inset: 0;
        display: block;
        width: 100%;
        height: 100%;
        object-position: center center;
        transition: opacity 240ms ease;
      }

      .homepage-bestsellers-family__image img.primary {
        object-fit: contain;
        opacity: 1;
      }

      .homepage-bestsellers-family__image img.secondary {
        object-fit: cover !important;
        opacity: 0;
      }

      @media (hover: hover) and (pointer: fine) {
        .homepage-bestsellers-family__card a:hover .homepage-bestsellers-family__image img.primary {
          opacity: 0;
        }

        .homepage-bestsellers-family__card a:hover .homepage-bestsellers-family__image img.secondary {
          opacity: 1;
        }
      }
    `;
    if (!style.parentNode) document.head.appendChild(style);
  };

  const cardHtml = (product) => {
    const hoverImage = product.hoverImage || product.image;

    return `
    <div class="homepage-bestsellers-family__card">
      <a href="${escapeHtml(product.url)}" aria-label="${escapeHtml(product.title)}">
        <span class="homepage-bestsellers-family__image">
          <img class="primary" src="${escapeHtml(product.image)}" width="1400" height="1540" alt="${escapeHtml(product.title)}" loading="lazy">
          <img class="secondary hover hover--cover" src="${escapeHtml(hoverImage)}" width="1400" height="1540" alt="" loading="lazy" aria-hidden="true">
        </span>
        <span class="homepage-bestsellers-family__meta">
          <span>${escapeHtml(product.title)}</span>
          <span class="homepage-bestsellers-family__price">${escapeHtml(product.price)}</span>
        </span>
      </a>
    </div>`;
  };

  const replaceHomepageRail = () => {
    const section = findLifeSection();
    if (!section) return false;

    let changed = false;

    if (!document.getElementById('a-life-in-letters')) {
      const anchor = document.createElement('span');
      anchor.id = 'a-life-in-letters';
      anchor.className = 'life-in-letters-anchor';
      anchor.setAttribute('aria-hidden', 'true');
      section.before(anchor);
      changed = true;
    }

    const heading = section.querySelector('.grid__heading');
    if (heading && heading.textContent.trim() !== 'A Life in Letters') {
      heading.textContent = 'A Life in Letters';
      changed = true;
    }

    const description = section.querySelector('.grid__description');
    if (description && description.textContent.trim() !== 'Shop the Golden Hour letters.') {
      description.innerHTML = '<p>Shop the Golden Hour letters.</p>';
      changed = true;
    }

    const rail = section.querySelector('.homepage-bestsellers-family__rail');
    const firstCardText = rail?.querySelector('.homepage-bestsellers-family__meta span')?.textContent?.trim();
    const hasHoverImages = !!rail?.querySelector('.homepage-bestsellers-family__image img.secondary');
    const hasCoverHoverImages = !!rail?.querySelector('.homepage-bestsellers-family__image img.secondary.hover.hover--cover');
    if (rail && (firstCardText !== products[0].title || !hasHoverImages || !hasCoverHoverImages)) {
      rail.innerHTML = products.map(cardHtml).join('');
      changed = true;
    }

    return changed;
  };

  const refresh = () => {
    if (!isHome()) return;
    ensureHoverStyles();
    replaceBackdrop();
    replaceHomepageRail();
  };

  const scheduleRefreshes = () => {
    [0, 250, 1000, 2500, 5000].forEach((delay) => window.setTimeout(refresh, delay));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleRefreshes, { once: true });
  } else {
    scheduleRefreshes();
  }

  window.addEventListener('load', refresh, { once: true });
  document.addEventListener('shopify:section:load', refresh);
})();
